module.exports = __webpack_public_path__ + "img/pay-2.d70586c2.jpeg";